




























import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import { CancelReason, EPromotionStatus } from '@/services/connecteur'
import { DataRetourActionComponent } from '@/models/utils'
import serviceModule from '@/store/modules/ServiceModule'

@Component({
  components: {}
})
export default class CancelDialog extends Mixins(BaseVue) {
  @Prop({ default: false })
  public value!: boolean

  @Prop({ required: true })
  public salesOrgId!: number

  @Prop()
  public currentStatus!: EPromotionStatus

  public listOfPossibleReason: CancelReason[] = []
  public selectReason = 0

  public confirm () {
    let data: DataRetourActionComponent | undefined
    if (this.needReason) {
      data = new DataRetourActionComponent(
        EPromotionStatus.CANCELLED,
        this.selectReason
      )
    } else {
      data = new DataRetourActionComponent(EPromotionStatus.UNDONE)
    }

    this.$emit('confirm', data)
  }

  @Watch('value')
  public async updateSalesOrgIdPromotion () {
    try {
      if (this.value && this.needReason) {
        const response: CancelReason[] = await serviceModule.cancelReasonApi.getCancelReasons(
          this.salesOrgId
        )
        this.listOfPossibleReason = response
      }
    } catch (err) {
      this.displayError(err)
    }
  }

  public get needReason (): boolean {
    return this.currentStatus === EPromotionStatus.APPROVED
  }
}
